export function intersects<T>(a?: T[], b?: T[]): boolean {
  return Boolean(a && b?.some((item) => a.includes(item)))
}

/**
 * Returns `true` when `item` exists in `positive`
 * and does not exist in `negative`.
 */
export const containsExclusive = <T>(
  item: T,
  positive: ReadonlyArray<T>,
  negative: ReadonlyArray<T>,
): boolean => positive.includes(item) && !negative.includes(item)

export const intersectsExclusive = <T>(
  items: ReadonlyArray<T>,
  positive: ReadonlyArray<T>,
  negative: ReadonlyArray<T>,
): boolean => items.some((item) => containsExclusive(item, positive, negative))
